export enum NursingServiceChannel {
  CREATE = 'nursingService::create',
  EDIT = 'nursingService::patch',
  DELETE = 'nursingService::delete',
}
